<!-- 产品标签 -->
<template>
  <BaseFormItem2
    class="inner_box_label"
    :label="fields.label"
    :labelTips="fields.labelTips"
    :labelTipsWidth="fields.labelTipsWidth"
    :fillTips="fillTips"
    :isError="isError"
    :isErrorBlink="isErrorBlink"
    :isShake="isShake"
  >
    <BaseRadioGroup2 :isError="isError" v-model="val.inner_box_label">
      <BaseTipPopover 
        v-for="item in fields.options"
        :key="item.value" 
        :content="item.tips" 
        :disabled="!item.tips"
      >
        <el-radio-button
          slot="reference"
          :label="item.value"
          :disabled="item.disabled"
          @click.native.prevent="handleRadioClick(item.value)"
        >
          {{ item.label }}
          <template v-if="item.value === 1 && !!val.custom_id">
            <el-button type="text" class="inner_box_label__changeBtn" @click.stop="handleOpenDialog">
              &nbsp;&nbsp;{{ val.custom_name }}-修改
            </el-button>
          </template>
        </el-radio-button>
      </BaseTipPopover>
    </BaseRadioGroup2>
    <BaseLink slot="other" href="https://www.hqpcb.com/help/p_1884.html" target="_blank">标签操作说明</BaseLink>
    <!-- 自定义标签列表弹框 -->
    <CustomTagDialog ref="customTagDialogRef" @delete="handleDelete" @confirm="handlConfirm" />
    <!-- 无需标签二次确认弹框 -->
    <InnerBoxLabelTipsDialog ref="innerBoxLabelTipsDialogRef" @change="handleSecondConfirm" />
  </BaseFormItem2>
</template>

<script>
import CustomTagDialog from '@@/views/pcb/components/customTagDialog'
import InnerBoxLabelTipsDialog from '@@/views/pcb/components/innerBoxLabelTipsDialog'

import { getFR4Fields } from '@@/utils/getFields'
import { getCustomTagsList } from '@@/api/pcb'

export default {
  props: {
    // 内箱标签
    inner_box_label: {
      type: [Number, String],
      default: ''
    },
    // 自定义标签id
    custom_id: {
      type: [String, Number],
      default: ''
    },
    // 自定义标签名称
    custom_name: {
      type: String,
      default: ''
    },
    // 返回修改初始化参数时，参数不进行关联变更
    initPcbParamsChange: {
      type: Boolean,
      default: false
    }
  },
  components: {
    CustomTagDialog,
    InnerBoxLabelTipsDialog
  },
  data() {
    return {
      val: {
        inner_box_label: this.inner_box_label,
        custom_id: this.custom_id,
        custom_name: this.custom_name
      },
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
      isShake: false, // 是否抖动两下
    }
  },
  computed: {
    fields() {
      return getFR4Fields('inner_box_label')
    },
    // 是否显示未填写样式
    fillTips() {
      const val = this.val.inner_box_label
      return !val && val !== 0
    }
  },
  watch: {
    inner_box_label(newVal) {
      this.val.inner_box_label = newVal
    },
    custom_id(newVal) {
      this.val.custom_id = newVal
    },
    custom_name(newVal) {
      this.val.custom_name = newVal
    },
  },
  mounted() {
    this.$nextTick(() => {
      const id = this.$route.query.id
      if (!id && !this.initPcbParamsChange) {
        this.getUserInnerBoxLabel()
      }
    })
  },
  methods: {
    // 获取用户设置产品标签的默认值
    getUserInnerBoxLabel() {
      getCustomTagsList()
        .then(res => {
          if (res) {
            const user_inner_box_label = (res.result || {}).user_inner_box_label
            if (user_inner_box_label) {
              // -1：未设置 默认选中需要标签
              this.val.inner_box_label = user_inner_box_label === '-1' ? 0 : +user_inner_box_label
              this.handleEmit(['inner_box_label'])
            }
          }
        })
    },
    handleEmit(keys) {
      keys.forEach(key => {
        this.$emit(`update:${key}`, this.val[key])
      })
      this.handleEmitChange()
      this.isShowError(false)
    },
    handleEmitChange() {
      this.$emit('change', { ...this.val })
    },
    handleRadioClick(inner_box_label) {
      // 当选择 自定义标签，且没选择自定义的标签时
      if (inner_box_label === 1 && !this.val.custom_id) {
        this.handleOpenDialog()
      } else {
        // 当切换到 无需 时，显示二次确认提示弹框
        if (inner_box_label == 2 && this.val.inner_box_label != 2) {
          this.$refs.innerBoxLabelTipsDialogRef.open()
        }
        this.val.inner_box_label = inner_box_label
        this.handleEmit(['inner_box_label'])
      }
    },
    // 提示弹框 二次确认
    handleSecondConfirm(inner_box_label) {
      this.val.inner_box_label = inner_box_label
      this.handleEmit(['inner_box_label'])
    },
    // 打开弹框
    handleOpenDialog() {
      this.$refs.customTagDialogRef.open(this.val.custom_id)
    },
    // 确认选择标签
    handlConfirm(custom_id, custom_name) {
      this.val = { inner_box_label: 1, custom_id, custom_name }
      this.handleEmit(['inner_box_label', 'custom_id', 'custom_name'])
    },
    // 删除标签
    handleDelete(id) {
      // 如果删除的是当前选中的标签，则清空当前选中的
      if (id == this.val.custom_id) {
        this.val = Object.assign(this.val, { custom_id: '', custom_name: '' })
        this.handleEmit(['custom_id', 'custom_name'])
      }
    },
    // 是否显示错误提示样式
    isShowError(isError) {
      this.isError = isError
    },
    // 是否抖动两下
    isShowShake(isShake) {
      this.isShake = isShake
      const timer = setTimeout(() => {
        this.isShake = false
        clearTimeout(timer)
      }, 300)
    },
  }
}
</script>

<style lang="scss" scoped>
.inner_box_label {
  .inner_box_label__changeBtn {
    margin-left: 2px;
    padding: 0;
    border: 0;
    border-left: $--border-base;
    color: $--form-color-base;
  }
}
</style>